export enum Currency {
  PEN = "PEN",
}

export enum DiscountTypeEnum {
  FIXED = 'FIXED',
  PERCENTAGE = 'PERCENTAGE',
}

export enum Unit {
  UNIT = "UNIT",
  GRAM = "GRAM",
  KILOGRAM = "KILOGRAM",
  MILLIGRAM = "MILLIGRAM",
  METER = "METER",
  SQUARE_METER = "SQUARE_METER",
  CUBIC_METER = "CUBIC_METER",
  CENTIMETER = "CENTIMETER",
  SQUARE_CENTIMETER = "SQUARE_CENTIMETER",
  CUBIC_CENTIMETER = "CUBIC_CENTIMETER",
  MILLIMETER = "MILLIMETER",
  SQUARE_MILLIMETER = "SQUARE_MILLIMETER",
  CUBIC_MILLIMETER = "CUBIC_MILLIMETER",
  OUNCE = "OUNCE",
  POUND = "POUND",
  FOOT = "FOOT",
  SQUARE_FOOT = "SQUARE_FOOT",
  CUBIC_FOOT = "CUBIC_FOOT"
}

export enum RelatedProductsTypeEnum {
  CROSSSELLING = "CROSSSELLING",
  UPSELLING = "UPSELLING"
}

export enum StatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE"
}

export class Stock {
  branchId: string;
  branchName: string | null;
  quantity: number;
  stockAvailable: number;
  stockReserved: number;
  stockFulfilled: number; 

  constructor() {
    this.branchId = '';
    this.branchName = null;
    this.stockAvailable = 0;
    this.stockReserved = 0;
    this.quantity = 0;
    this.stockFulfilled = 0;
  }
}
export interface ProductRow {
  productId: string;
  name: string;
  sku: string;
  branchId: string;
  branchName: string | null;
  stockReserved: number | null; 
  stockAvailable: number | null;
  quantity: number | null; 
  stockFulfilled: number | null;
}
export class FinalRegularPrice {
  id: string;
  amount: number;
  currency: Currency;
  branchId: string;

  constructor() {
    this.id = '';
    this.amount = 0;
    this.currency = Currency.PEN;
    this.branchId = '';
  }
}

export class FinalBasePrice {
  amount: number;
  currency: Currency;

  constructor() {
    this.amount = 0;
    this.currency = Currency.PEN;
  }
}

export class Discount {
  id: string;
  code: string;
  type: 'FIXED' | 'PERCENTAGE';
  value: number;
  branchId: string | null;
  expiration: string;

  constructor() {
    this.id = '';
    this.code = '';
    this.type = 'PERCENTAGE';
    this.value = 0;
    this.branchId = null;
    this.expiration = '';
  }
}

export class ProductRelationDto {
  id: string;
  relatedProductId: string;
  relatedProductImg: string;
  relatedProductName: string;
  relatedProductSku: string;

  constructor() {
    this.id = '';
    this.relatedProductId = '';
    this.relatedProductImg = '';
    this.relatedProductName = '';
    this.relatedProductSku = ''
  }
}

export class GroupedProductRelationDto {
  type: RelatedProductsTypeEnum;
  relatedSkus: ProductRelationDto[];

  constructor() {
    this.type = RelatedProductsTypeEnum.CROSSSELLING;
    this.relatedSkus = [];
  }
}

export class BrandDto {
  id: string;
  name: string;

  constructor() {
    this.id = "";
    this.name = "";
  }
}


export class ProductImage {
  url: string;
  altText: string;
  order: number;

  constructor() {
    this.url = "";
    this.altText = "";
    this.order = 0;
  }
}
export class CategoryReference {
  id: string;
  name: string;

  constructor() {
    this.id = "";
    this.name = "";
  }
}

export class ProductSEO {
  keywords: string;
  permalink: string;
  metaTitle: string;
  metaDescription: string;

  constructor() {
    this.keywords = "";
    this.permalink = "";
    this.metaTitle = "";
    this.metaDescription = "";
  }
}

export class BasePrice {
  amount: number;
  currency: Currency;

  constructor() {
    this.amount = 0;
    this.currency = Currency.PEN;
  }
}

export class StockManagement {
  unit: Unit;
  quantity: number;

  constructor() {
    this.unit = Unit.UNIT;
    this.quantity = 0;
  }
}


export class ProductDimensions {
  heightInCm: number;
  widthInCm: number;
  lengthInCm: number;
  weightInGrams: number;

  constructor() {
    this.heightInCm = 0;
    this.widthInCm = 0;
    this.lengthInCm = 0;
    this.weightInGrams = 0;
  }
}
export type NutritionalWarning =
  | "HIGH_IN_SUGAR"
  | "HIGH_SODIUM"
  | "HIGH_IN_SATURATED_FAT"
  | "CONTAIN_TRANS_FATS"
  | "AVOID_ITS_CONSUMPTION"
  | "AVOID_EXCESSIVE_CONSUMPTION";

export class Specification {
  attribute: string;
  attributeLabel: string;
  value: number | string;

  constructor() {
    this.attribute = '';
    this.attributeLabel = '';
    this.value = '';
  }
}
export interface ProductInPack {
  productId: string;
  quantity: number;
  unitPrice: number;
}

export class Product {
  id: string | null;
  storeId: string | null;
  externalId: string;
  sku: string;
  ean: string;
  name: string;
  description: string;
  images: ProductImage[];
  brand: BrandDto;
  category: CategoryReference;
  seo: ProductSEO;
  basePrice: BasePrice;
  stockManagement: StockManagement;
  nutritionalWarnings: string[];
  dimensions: ProductDimensions;
  pricing: PricingDto;
  specifications: Specification[];
  showWithoutStock: boolean;
  status: StatusEnum;
  productRelations: GroupedProductRelationDto[] | null;

  score: number | null;
  releaseDate: string | null;
  stocks: Stock[];
  discount: Discount | null;
  finalBasePrice: FinalBasePrice | null;
  finalRegularPrices: FinalRegularPrice[];
  bundle?: boolean;
  bundleItems?: ProductInPack[];
  constructor() {
    this.id = null;
    this.storeId = null;
    this.externalId = '';
    this.sku = '';
    this.ean = '';
    this.name = '';
    this.description = '';
    this.images = [new ProductImage()];
    this.brand = new BrandDto();
    this.category = new CategoryReference();
    this.seo = new ProductSEO();
    this.basePrice = new BasePrice();
    this.stockManagement = new StockManagement();
    this.nutritionalWarnings = [];
    this.dimensions = new ProductDimensions();
    this.pricing = {
      base: { amount: 0, currency: Currency.PEN },
      branches: [],
    };
    this.specifications = [];
    this.showWithoutStock = true;
    this.status = StatusEnum.INACTIVE;
    this.productRelations = null;
    this.bundle = false;

    // Nuevos campos
    this.score = null;
    this.releaseDate = null;
    this.stocks = [];
    this.discount = null;
    this.finalBasePrice = null;
    this.finalRegularPrices = [];
    this.bundleItems = [];
    this.bundle = false;
  }
}

export interface IImageList {
  url: string;
  altText: string;
  order: number;
}

export interface ICategoryList {
  id: string;
  externalId: string;
  name: string;
}

export interface ISeoList {
  keywords: string;
  permalink: string;
  metaTitle: string;
  metaDescription: string;
}

export interface IStockManagementList {
  unit: string;
  quantity: number;
}

export interface IDimensionsList {
  heightInCm: number;
  widthInCm: number;
  lengthInCm: number;
  weightInGrams: number;
}

export interface IBasePrice {
  amount: number;
  currency: string;
}
export interface ISpecification {
  attribute: string;
  attributeLabel: string;
  value: string | number;
}
export interface IStock {
  branchId: string;
  branchName: string | null;
  quantity: number;
  stockReserved: number;
  stockAvailable: number;
  stockFulfilled: number;
}
export interface IProductList {
  id: string;
  externalId: string;
  sku: string;
  ean: string;
  active: boolean;
  name: string;
  description: string;
  images: IImageList[];
  brandName: string;
  category: ICategoryList;
  seo: ISeoList;
  stockManagement: IStockManagementList;
  nutritionalWarnings: string[];
  dimensions: IDimensionsList;
  basePrice: IBasePrice;
  totalStock: number;
  specifications: ISpecification[];
  status: StatusEnum;
  bundle?: boolean;
  bundleItems?: ProductInPack[];
  stocks: IStock[];
  isLocalProduct?: boolean; // Indica si el producto fue agregado localmente
}
export type ExportMode = 'products' | 'images';

export interface ProductListFilter {
  page?: number;
  size?: number;
  q?: string;
  categoryId?: string;
  brandId?: string;
  status?: string;
  timestamp?: number; 
  sort?: string[]; 
  skuIds?: string[];

}
export interface CreateProductResponse {
  id: string;
}
export interface UpdateBundleRequest {
  items: BundleItemDto[];
}
export interface BundleItemDto {
  productId: string;   // ID del producto hijo
  quantity: number;    // Cantidad del producto en el bundle
  unitPrice: number;   // Precio unitario de ese producto dentro del bundle
}

export interface BatchProductDetails {
  code: string;
  message: string;
}

export interface BatchProductResponse {
  operation: string;
  totalProcessed: number;
  successful: number;
  failed: number;
  details: BatchProductDetails[];
}

export interface PageDto {
  number: number;
  size: number;
  totalElements: number;
  totalPages: number;
  empty: boolean;
}

export interface ProductDtoV2Response {
  page: PageDto;
  items: IProductList[];
}
export type CurrencyOption = { label: string; value: string };

export class ProductPrice {
  id: string;
  storeSubsidiaryId: string;
  productId: string;
  label?: string;
  amount: number;
  currency: string | CurrencyOption;
  quantity?: number;
  branchId: string;
  constructor() {
    this.id = "";
    this.productId = "";
    this.storeSubsidiaryId = "";
    this.amount = 0;
    this.currency = "";
    this.quantity = 0;
    this.branchId = "";
  }
}
export interface ProductCatalogResponse {
  page: PageDto;
  items: ProductCatalogDto[];
}

export interface ProductCatalogDto {
  id: string;
  externalId: string;
  sku: string;
  ean: string;
  name: string;
  description: string;
  images: ImageDtoV2[];
  brand: BrandDto;
  category: FullCategoryDto;
  seo: SeoDtoV2;
  pricing: PricingDto;
  stock: StockDto;
  nutritionalWarnings: string[];
  dimensions: DimensionsDtoV2;
}

export interface ImageDtoV2 {
  id: string;
  productId: string;
  imageUrl: string;
  imageOrder: number;
  enabled: boolean;
}

export interface BrandDto {
  id: string;
  name: string;
}

export interface FullCategoryDto {
  id: string;
  externalId: string;
  name: string;
  path: CategoryPathDto[];
}

export interface CategoryPathDto {
  id: string;
  name: string;
  externalId: string;
}

export interface SeoDtoV2 {
  keywords: string;
  permalink: string;
  metaTitle: string;
  metaDescription: string;
}

export interface PricingDto {
  base: ExtendedPriceDto;
  branches: BranchPricingDto[];
}

export class ExtendedPriceDto {
  amount: number;
  currency: string;
  branchId?: string;
  branchName?: string;
  constructor() {
    this.amount = 0;
    this.currency = "PEN"
  }
}

export interface BranchPricingDto {
  id: string;
  name: string;
  prices: BranchPriceDto[];
}

export interface BranchPriceDto {
  id: string;
  amount: number;
  currency: string;
  type: string;
  quantity: number;
}

export class AddBranchPrice {
  branchId!: string;
  amount!: number;
  currency!: string;
  type!: string;
  quantity!: number;

  constructor() {
    this.branchId = "";
    this.amount = 0;
    this.currency = "PEN";
    this.type = "REGULAR";
    this.quantity = 0
  }
}

export interface StockDto {
  available: boolean;
  total: number;
  branch: BranchStockDto;
}

export interface BranchStockDto {
  branchId: string;
  quantity: number;
  available: boolean;
}

export interface DimensionsDtoV2 {
  heightInCm: number;
  widthInCm: number;
  lengthInCm: number;
  weightInGrams: number;
}
export interface UpdateStockDto {
  branchId: string;
  stock: number;
}

export class CreateOrEditBranchPrice {
  amount!: number | undefined;
  currency!: string | undefined;
  branchId!: string | undefined;
  quantity?: number | undefined;
  type?: string | undefined;
  constructor() {
    this.currency = "PEN";
    this.branchId = "";
    this.type = "REGULAR"
  }
}
export interface BranchDto {
  id: string;
  name: string | null;
}

export interface ProductPriceDto {
  priceId: string;
  branch: BranchDto;
  amount: number;
  currency: string;
  type: string;
  volumePrice: boolean;
  quantity: number;
  startDate: string;
  endDateAt: string | null;
}export type FilterOperator = 'gte' | 'lte' | 'between' | 'all';

export interface ColumnFilter {
  operator: FilterOperator;
  value1?: number;
  value2?: number;
}
